export const fullAutoOptions = {
    dispatchOnMount: true,
    dispatchOnUpdate: true,
    resetOnUnmount: true
};

export const currentCheckinOptions = {
    dispatchOnMount: true,
    dispatchOnUpdate: true
};

export const autoFetchOptions = {
    dispatchOnMount: true
};

export const formAutoOptions = {
    resetOnUnmount: true
};
